// extracted by mini-css-extract-plugin
export var chevronIcon = "_65-2";
export var teamName = "_65-1";
export var teamSwitcherButton = "_65-0";